var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[(_vm.type === 1)?[_c('img',{staticClass:"welcome-text",attrs:{"src":_vm.resolveAssetsURL(_vm.path),"alt":""}})]:[_c('video',{staticClass:"welcome-video",attrs:{"src":_vm.resolveAssetsURL(_vm.path)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }